module.exports = __webpack_public_path__ + "static/media/galerija_2023 (7).552a3aff.png";